import "./index.scss";
import { ListProps } from "./types";
import { insideBreakpoint, useBreakpoint } from "utilities/BreakpointProvider";
import DeafaultList from "./DefaultList";
import React from "react";
import Slider from "components/Slider";

const List = (props: ListProps) => {
  const breakpoints = useBreakpoint();
  const { activeSlider, children, ...otherProps } = props;
  let validBreakpoints;
  if (activeSlider && Array.isArray(activeSlider) === true) {
    validBreakpoints = activeSlider.filter((currentValue) => {
      return !!currentValue;
    });
  }

  if (
    !validBreakpoints ||
    Array.isArray(validBreakpoints) === false ||
    validBreakpoints.length === 0
  ) {
    validBreakpoints = ["xs"];
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {insideBreakpoint(breakpoints, validBreakpoints) || !activeSlider ? (
        <DeafaultList {...otherProps}>{children}</DeafaultList>
      ) : (
        <Slider {...otherProps} hasList>
          {children}
        </Slider>
      )}
    </>
  );
};

export default List;
